import {shortMonth, longMonth} from '../../../helpers/FormatMonth';

const SetFormattedDataValue = doThat => {
    return new Promise(resolve => {
        if (!doThat) {
            resolve(doThat);
            return;
        }

        [...document.querySelectorAll('[data-value-format][data-value]')].forEach(el => {
            const format = el.dataset.valueFormat;
            const val = el.dataset.value;
            switch (format) {
                case 'monthLong':
                    el.dataset.valueOutput = longMonth(val);
                    break;

                case 'monthShortAndLong':
                    el.dataset.valueOutputLong = longMonth(val);
                    el.dataset.valueOutputShort = shortMonth(val);
                    break;

                default:
                    el.dataset.valueOutput = val;
                    break;
            }
        });

        resolve(doThat);
    });
};

export {SetFormattedDataValue};
